import { TriangleAlert } from 'lucide-react';

import AskBlock from './AskBlock';
import MarkdownText from './MarkdownText';
import NavigateBlock from './NavigateBlock';
import ShowBlock from './ShowBlock';
import ToolStep from './ToolStep';

import { AGENT_BLOCK_TYPES } from '@/app/agentConversation/_enums';

import { Button } from '@/app/ui/button';
import { ErrorBoundary } from '@/app/ui/error';

const TextBlock = ({ block }) => (
  <div className="text-sm">
    <MarkdownText markdown={block.text} />
  </div>
);

const BLOCKS = {
  [AGENT_BLOCK_TYPES.TEXT]: TextBlock,
  [AGENT_BLOCK_TYPES.TOOL_STEP]: ToolStep,
  [AGENT_BLOCK_TYPES.SHOW]: ShowBlock,
  [AGENT_BLOCK_TYPES.ASK]: AskBlock,
  [AGENT_BLOCK_TYPES.NAVIGATE]: NavigateBlock
};

// Small enough to sit where the block would have been, so one bad block never
// takes the rest of the reply — or the app — with it.
const BlockFallback = ({ resetError }) => (
  <div className="text-muted-foreground my-1.5 flex items-center gap-2 text-xs" data-testid="agent-block-error">
    <TriangleAlert className="size-3.5" />
    This part couldn&apos;t be shown
    <Button variant="link" size="xs" className="h-auto p-0" onClick={resetError}>
      Retry
    </Button>
  </div>
);

/** One block of an assistant reply, in its own error boundary. Unknown types render nothing. */
const Block = ({ block, ...props }) => {
  const Component = BLOCKS[block.type];
  if (!Component) return null;

  return (
    <ErrorBoundary fallback={BlockFallback}>
      <Component block={block} {...props} />
    </ErrorBoundary>
  );
};

export default Block;
